import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class PerformanceService {
  public get timeOrigin() {
    return performance.timeOrigin;
  }

  public getEntriesByType(type: string): PerformanceEntryList {
    return performance.getEntriesByType(type);
  }
}
